'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export const usePageScroll = page => {
  const $ = _c(4);
  const [isInitialPage, setIsInitialPage] = useState(true);
  let t0;
  if ($[0] !== isInitialPage) {
    t0 = () => {
      if (isInitialPage) {
        setIsInitialPage(false);
      } else {
        window.scrollTo(0, 0);
      }
    };
    $[0] = isInitialPage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== page) {
    t1 = [page];
    $[2] = page;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t0, t1);
};